module.exports = __webpack_public_path__ + "img/42e4014.jpg";